import { CButton, CContainer } from '@coreui/react';
import * as React from 'react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { PDFDocumentProxy } from 'pdfjs-dist/types/src/display/api';
import { AppLabels } from '../core/AppLabels';

interface IProps {
	path: string;
}

interface IState {
	isOpen: boolean;
	numPages: number;
	currentPage: number;
	nextDisable: boolean;
	prevDisable: boolean;
}

export class KPDFViewer extends React.Component<IProps, IState> {

	constructor(props) {
		super(props);

		this.state = {
			isOpen: true,
			numPages: 0,
			currentPage: 0,
			nextDisable: false,
			prevDisable: false,
		}

		console.log("el condor passa : ");
		console.log(this.props.path);
	}

	//#region Local events

	onNextPageClick = () => {
		if (this.state.currentPage < this.state.numPages)
			this.setState({ currentPage: this.state.currentPage + 1 }, this.setButtonStates);
	}

	onPreviousPageClick = () => {
		if (this.state.currentPage > 1)
			this.setState({ currentPage: this.state.currentPage - 1 }, this.setButtonStates);
	}

	// Défini l'état des boutons précédent & suivant en fonction du nombre de pages et de la page courante
	setButtonStates = () => {
		this.setState({ prevDisable: (this.state.currentPage == 1) });
		this.setState({ nextDisable: (this.state.currentPage == this.state.numPages) });
	}

	// Click sur Fermer
	onCloseClick = () => {
		this.setState({ isOpen:false });
	}

	// Un fois le document chargé, on défini le nombre de pages et la page courante
	onDocumentLoadSuccess = (pdf: PDFDocumentProxy) => {
		this.setState({
			numPages: pdf.numPages,
			currentPage: 1,
			prevDisable: true,
			nextDisable: pdf.numPages == 1
		});
	}

	//#endregion Local events

	//#region Rendus

	render() {
		if (!this.state.isOpen) return "";

		return (
			<div className="KDrawingInput">
				<div className="KDrawingWrapper">
					<div className="KDrawing overflow-auto">

						<CContainer >
							<Document file={this.props.path} onLoadSuccess={this.onDocumentLoadSuccess}  >
								<Page pageNumber={this.state.currentPage} />
							</Document>
						</CContainer >

						<div className="controls">
							<CButton disabled={this.state.prevDisable} size="lg" color="success" onClick={this.onPreviousPageClick}> « </CButton>
							<CButton size="lg" color="primary" onClick={this.onCloseClick}> {AppLabels.close}</CButton >
							<CButton disabled={this.state.nextDisable} size="lg" color="danger" onClick={this.onNextPageClick}> » </CButton >
						</div>
					</div>
				</div>
			</div>
		)
	}

	//#endregion

}

